import Image, { StaticImageData } from "next/image";
import { ReactNode } from "react";

const Quote = ({ img, name, title, subtitle, children }: QuoteProps) => (
  <div className="slider__inner">
    <div className="slider__inner--image">
      <img src={typeof img === "string" ? img : img.src} alt={name} />
    </div>
    <div className="slider__inner--text">
      <div className="title-style">
        <h5>{name}</h5>
        <p>
          {title}
          <br />
          {subtitle}
        </p>
      </div>
    </div>
    <div className="text-style">
      <p>{children}</p>
    </div>
  </div>
);

interface QuoteProps {
  img: string | StaticImageData;
  name: string;
  title: string;
  subtitle: string;
  children: ReactNode;
}

export default Quote;
